/**
 * Setup the payment form
 */
const form = document.getElementById('payment-form');
if (form) {

  // Stripe client secret.
  const clientSecret = form.dataset.clientSecret;

  // Stripe elements.
  const elements = stripe.elements();
    
  const cardNumber = elements.create('cardNumber');
  cardNumber.mount('#cardNumber-element');

  const cardExpiry = elements.create('cardExpiry');
  cardExpiry.mount('#cardExpiry-element');

  const cardCvc = elements.create('cardCvc');
  cardCvc.mount('#cardCvc-element');

  const postalCode = elements.create('postalCode');
  postalCode.mount('#postalCode-element');

  // Validate the inputs.
  const inputs = [cardNumber, cardExpiry, cardCvc, postalCode];

  for (let i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('change', function(event) {
      let displayError = document.getElementById(event.elementType + '-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  };

  /**
   * Create a token or display an error when the form is submitted
   */
  form.addEventListener('submit', createPaymentMethodIdentifier);

  /**
   * Remove the Stripe form event listener
   */
  function removeStripe() {
    form.removeEventListener('submit', createPaymentMethodIdentifier);
  }

  /** 
   * Create the Stripe Payment Method Identifier
   */
  function createPaymentMethodIdentifier(event) {
    event.preventDefault();

    // Disable submit button
    let btn = document.querySelector('button[type="submit"]');
    btn.disabled = true;

    // Show button loading icon
    let loadingIcon = btn.querySelector('.fa');
    if (loadingIcon) {
      loadingIcon.classList.remove('hidden');
    }

    // Gather additional customer data we may have collected in our form
    const firstName = form.querySelector('[data-billing="first_name"]');
    const lastName  = form.querySelector('[data-billing="last_name"]');
    const address1  = form.querySelector('[data-billing="address"]');
    const address2  = form.querySelector('[data-billing="address_2"]');
    const city      = form.querySelector('[data-billing="city"]');
    const state     = form.querySelector('[data-billing="state"]');
    const country   = 'US';
    const additionalData = {
      name: (firstName && lastName) ? firstName.value + ' ' + lastName.value : undefined,
      address: {
        line1:   address1 ? address1.value : undefined,
        line2:   address2 ? address2.value : undefined,
        city:    city ? city.value : undefined,
        state:   (state && country == 'US') ? state.value : undefined,
        country: country
      }
    };

    // Required data
    if (
      additionalData['name'] == undefined || additionalData['name'] == '' ||
      additionalData['address'] == undefined || additionalData['address'] == '' ||
      additionalData['address']['line1'] == undefined || additionalData['address']['line1'] == '' ||
      additionalData['address']['city'] == undefined || additionalData['address']['city'] == '' ||
      additionalData['address']['state'] == undefined || additionalData['address']['state'] == ''
    ) {
      let errorElement = document.getElementById('payment-errors');
      errorElement.textContent = 'Please enter all required payment fields.';
      btn.disabled = false;

      if (loadingIcon) {
        loadingIcon.classList.add('hidden');
      }

      return false;
    }

    // See: https://stripe.com/docs/stripe-js/reference#stripe-handle-card-setup
    stripe.handleCardSetup(clientSecret, cardNumber, {
      payment_method_data: {
        billing_details: additionalData
      }
    })
    .then(function(result) {
      if (result.error) {
        let errorElement = document.getElementById('payment-errors');
        errorElement.textContent = result.error.message;
        btn.disabled = false;

        if (loadingIcon) {
          loadingIcon.classList.add('hidden');
        }
      } else {
        stripeSetupIntentHandler(result.setupIntent);
      }
    });
  }

  /**
   * Insert the setupIntent payment method into the form so it gets submitted to the server.
   */
  function stripeSetupIntentHandler(setupIntent) {
    const form = document.getElementById('payment-form');
    const hiddenInput = document.createElement('input');

    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.setAttribute('name', 'paymentMethod');
    hiddenInput.setAttribute('value', setupIntent.payment_method);
    form.appendChild(hiddenInput);
    form.submit();
  }
}
